import {load} from '@shopify/theme-sections';
import '../sections/collection';

document.addEventListener('DOMContentLoaded', () => {
  load('*');
});
